import { render, staticRenderFns } from "./OnboardingHome.vue?vue&type=template&id=21de906e&"
import script from "./OnboardingHome.vue?vue&type=script&lang=js&"
export * from "./OnboardingHome.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingHome.vue?vue&type=style&index=0&id=21de906e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports